;(function($, undefined){

    var rnn = window.rnn;

    function scrollingDesktopNav() {
        var $nav = $('.desktopNav .nav');
        var $navControls = $('.nav-controls');
        var $navControlItems = $('.nav-controls a');
        var isScrollable = $nav[0] && $nav[0].scrollWidth > 984 || false;

        if(isScrollable) {
            $navControls.removeClass('hide');
            $navControls.siblings('.nav').addClass('scrollable');

            var scrollSettings = {
                left: 0,
                right: $nav[0].scrollWidth - $nav[0].offsetWidth,
                dir: 'right',
                pos: 0
            };

            // On Click --> Animated Scroll
            $navControlItems.click(function() {
                // Update 'dir' and 'pos' properties based on click event
                scrollSettings.dir = $(this).hasClass('nav-controls-right') ? 'right' : 'left';
                scrollSettings.pos = scrollSettings.dir === 'right' ? scrollSettings.right : scrollSettings.left;

                // Animate scroll
                $nav.animate({
                    scrollLeft: scrollSettings.pos
                }, 800);

                // Update controls
                disableControls($navControlItems, scrollSettings.pos, scrollSettings.left, scrollSettings.right);

                return false;
            });

            // Manual Scrolling
            $nav.scroll(function() {
                // Update controls
                disableControls($navControlItems, $nav[0].scrollLeft, scrollSettings.left, scrollSettings.right);
            });
        }
    }

    function disableControls($controls, currentPos, leftPos, rightPos) {
        var $leftCtrl = $controls.closest('.nav-controls-left');
        var $rightCtrl = $controls.closest('.nav-controls-right');

        if(currentPos === leftPos) {
            $leftCtrl.addClass('disabled');
            $rightCtrl.removeClass('disabled');
        } else if (currentPos === rightPos) {
            $leftCtrl.removeClass('disabled');
            $rightCtrl.addClass('disabled');
        } else {
            $leftCtrl.removeClass('disabled');
            $rightCtrl.removeClass('disabled');
        }
    }


    /////////////////////
    // Initialise Nav
    /////////////////////
    function initNav() {
        scrollingDesktopNav();
    }

    rnn.modules.register("nav", {
        init: initNav
    });

})(jQuery);
